module.exports = __webpack_public_path__ + "static/media/Hover3.e845c5fe.svg";